import { render, staticRenderFns } from "./contactAbout.vue?vue&type=template&id=28dfcb7a&"
import script from "./contactAbout.vue?vue&type=script&lang=js&"
export * from "./contactAbout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports